import { Horizontal } from '@gravitate-js/excalibrr'
import * as React from 'react'
import { useSurchargeData } from './hooks'
import type { SurchargeTabProps } from './types'
import { CreateSurchargeDrawer } from './components/CreateSurchargeDrawer'
import { RateHistoryDrawer } from './components/RateHistoryDrawer'
import { SurchargeGrid } from './components/SurchargeGrid'

/**
 * Main component for the Surcharge tab in the Ratebook Drill-in view
 * Manages surcharge data, grids, and drawers for creating/editing surcharges and viewing rate history
 */
export function SurchargeTab({ ratebook }: SurchargeTabProps) {
  const {
    surcharges,
    isLoading,
    refetch,
    gridRef,
    selectedSurcharge,
    showRateHistory,
    showCreateDrawer,
    handleCloseRateHistory,
    handleCloseCreateDrawer,
    handleRateChange,
    handleEditSurcharge,
    handleViewRateHistory,
    handleAddSurcharge,
  } = useSurchargeData(ratebook)

  return (
    <Horizontal style={{ margin: '0px -1em', height: '100%' }}>
      <SurchargeGrid
        surcharges={surcharges}
        isLoading={isLoading}
        onEdit={handleEditSurcharge}
        onViewRateHistory={handleViewRateHistory}
        gridRef={gridRef}
        refreshData={refetch}
        ratebook={ratebook}
        onAddSurcharge={handleAddSurcharge}
      />

      {selectedSurcharge && (
        <RateHistoryDrawer
          surcharge={selectedSurcharge}
          open={showRateHistory}
          onClose={handleCloseRateHistory}
          onRateChange={handleRateChange}
        />
      )}

      <CreateSurchargeDrawer
        ratebook={ratebook}
        visible={showCreateDrawer}
        onClose={handleCloseCreateDrawer}
        onSuccess={handleRateChange}
        editingSurcharge={selectedSurcharge}
      />
    </Horizontal>
  )
}
